import { Card } from './primitives/Card';
import './MetricTile.css';

interface MetricTileProps {
  label: string;
  value: string;
  unit?: string;
  sub?: React.ReactNode;
  spark?: 'line' | 'bars' | 'dots';
}

export function MetricTile({ label, value, unit, sub, spark = 'line' }: MetricTileProps) {
  return (
    <Card variant="glass" className="tile">
      <div className="tile__label">{label}</div>
      <div className="tile__value">
        {value}
        {unit && <span className="tile__unit"> {unit}</span>}
      </div>
      {sub && <div className="tile__sub">{sub}</div>}
      <div className="tile__spark">
        {spark === 'line' && <SparkLine />}
        {spark === 'bars' && <SparkBars />}
        {spark === 'dots' && <SparkDots />}
      </div>
    </Card>
  );
}

function SparkLine() {
  return (
    <svg viewBox="0 0 200 36" preserveAspectRatio="none">
      <defs>
        <linearGradient id="sl-fill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#4ade80" stopOpacity="0.4" />
          <stop offset="1" stopColor="#4ade80" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d="M0,28 L20,24 L40,26 L60,18 L80,20 L100,12 L120,16 L140,8 L160,10 L180,4 L200,6"
            fill="none" stroke="var(--green)" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M0,28 L20,24 L40,26 L60,18 L80,20 L100,12 L120,16 L140,8 L160,10 L180,4 L200,6 L200,36 L0,36 Z"
            fill="url(#sl-fill)" opacity="0.5" />
    </svg>
  );
}

function SparkBars() {
  const heights = [14, 20, 12, 24, 18, 28, 22, 16, 26, 20, 30, 24];
  return (
    <svg viewBox="0 0 200 36" preserveAspectRatio="none">
      {heights.map((h, i) => (
        <rect key={i} x={6 + i * 16} y={34 - h} width="10" height={h} rx="2"
              fill={i === heights.length - 1 ? 'var(--green)' : 'var(--green-bright)'}
              opacity={i === heights.length - 1 ? 1 : 0.7} />
      ))}
    </svg>
  );
}

function SparkDots() {
  const top = Array.from({ length: 8 }, (_, i) => 14 + i * 20);
  const bot = Array.from({ length: 8 }, (_, i) => 14 + i * 20);
  return (
    <svg viewBox="0 0 200 36" preserveAspectRatio="none">
      {top.map((x, i) => <circle key={`t${i}`} cx={x} cy={18} r="6" fill="var(--green)" />)}
      {bot.map((x, i) => (
        <circle key={`b${i}`} cx={x} cy={30} r="3"
                fill={i >= 6 ? 'var(--amber)' : 'var(--green)'} />
      ))}
    </svg>
  );
}
